import { createFileRoute } from "@tanstack/react-router";
import { GreetingLanding } from "@/site/pages/greeting-landing";

// Legacy `/happy_birthday` — the day-of "Send Own Birthday" greeting (PRD 13 D18: the
// page is reimplemented, the 3-hour hard-login its handler minted is not).
export const Route = createFileRoute("/happy_birthday")({
  component: () => <GreetingLanding occasion="birthday" />,
});
